function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurso24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Capa 2",
    viewBox: "0 0 77.82 55.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M74.58 12.96H16.21V3.24A3.24 3.24 0 0 0 12.97 0H3.25C1.45 0 0 1.45 0 3.24v48.6c0 1.79 1.45 3.24 3.25 3.24h9.73a3.24 3.24 0 0 0 3.24-3.24v-9.72h45.39v9.72c0 1.79 1.45 3.24 3.25 3.24h9.73a3.24 3.24 0 0 0 3.24-3.24V16.2a3.24 3.24 0 0 0-3.24-3.24ZM71.33 48.6h-3.24v-9.72a3.24 3.24 0 0 0-3.24-3.24H12.97a3.24 3.24 0 0 0-3.24 3.24v9.72H6.48V6.48h3.25v22.68a3.24 3.24 0 0 0 3.24 3.24h58.36v16.2Zm0-22.68H16.21v-6.48h55.12v6.48Z",
    "data-name": "Capa 1",
    style: {
      fill: "#b7a662"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso24);
export default __webpack_public_path__ + "static/media/Recurso-24.77100e230bf89614380632b4de07cae7.svg";
export { ForwardRef as ReactComponent };